import { all } from 'redux-saga/effects';

import featureFlagsSaga from '../reducers/featureFlags/saga';
import unleashFeatureFlagsSaga from '../reducers/featureFlags/unleash/saga';
import ftueSaga from '../reducers/ftue/saga';
import inventoryFeatureSagas from '../reducers/inventoryFeatures/saga';
import pushNotificationSaga from '../reducers/pushNotification/saga';

import authSaga from './auth';
import billingNotificationSaga from './billingNotification';
import billingRedirectSaga from './billingRedirect';
import businessSaga from './business';
import calendarSaga from './calendar';
import capitalSaga from './capital/index';
import confirmActionSaga from './confirm-action';
import confirmEmployeeSaga from './confirmEmployee';
import dashboardSaga from './dashboard/index';
import employeesSaga from './employees';
import exampleFormSaga from './example/form';
import getExportedFileSaga from './get-exported-file';
import importCustomers from './uploaders/importCustomer';
import inventorySaga from './inventory';
import kybSaga from './kyb/index';
import librarySaga from './library';
import businessLibrarySaga from './businessLibrary';
import miscSaga from './misc';
import notificationSaga from './notifications';
import openPlatformSaga from './openPlatform';
import outletPageSaga from './outletPages';
import outletSaga from './outlet';
import reportsSaga from './reports';
import settingSaga from './setting';
import subscriptionExpiredSaga from './subscriptionExpired';
import uploadImageSaga from './uploadImage/index';
import userPropertiesSaga from './userProperties';
import exportingSaga from './exporting';

export default function* rootSaga() {
  yield all([
    authSaga(),
    billingNotificationSaga(),
    billingRedirectSaga(),
    businessLibrarySaga(),
    businessSaga(),
    calendarSaga(),
    capitalSaga(),
    confirmActionSaga(),
    confirmEmployeeSaga(),
    dashboardSaga(),
    employeesSaga(),
    exampleFormSaga(),
    featureFlagsSaga(),
    unleashFeatureFlagsSaga(),
    ftueSaga(),
    getExportedFileSaga(),
    importCustomers(),
    inventorySaga(),
    inventoryFeatureSagas(),
    kybSaga(),
    librarySaga(),
    miscSaga(),
    notificationSaga(),
    openPlatformSaga(),
    outletPageSaga(),
    outletSaga(),
    pushNotificationSaga(),
    reportsSaga(),
    settingSaga(),
    subscriptionExpiredSaga(),
    uploadImageSaga(),
    userPropertiesSaga(),
    exportingSaga(),
  ]);
}
